import React from 'react';
import { Calendar, User, Heart, Settings, Bell, ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';


function Dashboard() {
    const navigate = useNavigate();

  return (
    <div className="min-vh-100 bg-light">
      {/* Header */}
      <nav className="bg-white shadow-sm py-3">
        <div className="container">
          <div className="d-flex justify-content-between align-items-center">
            <a onClick={() => navigate(-1)} className="text-decoration-none text-dark d-flex align-items-center" style={{cursor: "pointer"}}>
              <ArrowLeft className="me-2" size={20} />
              Back
            </a>
            <h4 className="mb-0 fw-bold text-warning">Mobile Body Therapy</h4>
            <div style={{width: '120px'}}></div>
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <div className="container py-5">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            {/* Coming Soon Message */}
            <div className="text-center mb-5">
              <div className="mb-4">
                <div 
                  className="bg-warning bg-opacity-25 rounded-circle d-inline-flex align-items-center justify-content-center"
                  style={{width: '100px', height: '100px'}}
                >
                  <Settings className="text-warning" size={50} />
                </div>
              </div>
              <h1 className="display-4 fw-bold text-dark mb-3">Dashboard Coming Soon!</h1>
              <p className="lead text-muted mb-4">
                We're building something amazing for you. Stay tuned!
              </p>
              <a onClick={() => navigate(-1)} className="btn btn-warning text-dark px-4 py-2 fw-semibold" style={{cursor: "pointer"}}>
                Book an Appointment
              </a>
            </div>

            {/* Feature Preview Cards */}
            <div className="row g-4 mt-5">
              <div className="col-md-6 col-lg-3">
                <div className="bg-white rounded shadow p-4 text-center h-100">
                  <div className="bg-primary bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                       style={{width: '60px', height: '60px'}}>
                    <Calendar className="text-primary" size={30} />
                  </div>
                  <h5 className="fw-bold mb-2">My Appointments</h5>
                  <p className="text-muted small mb-0">
                    View and manage all your upcoming and past sessions
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3">
                <div className="bg-white rounded shadow p-4 text-center h-100">
                  <div className="bg-success bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                       style={{width: '60px', height: '60px'}}>
                    <User className="text-success" size={30} />
                  </div>
                  <h5 className="fw-bold mb-2">Profile</h5>
                  <p className="text-muted small mb-0">
                    Manage your personal information and preferences
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3">
                <div className="bg-white rounded shadow p-4 text-center h-100">
                  <div className="bg-warning bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                       style={{width: '60px', height: '60px'}}>
                    <Heart className="text-warning" size={30} />
                  </div>
                  <h5 className="fw-bold mb-2">Rewards</h5>
                  <p className="text-muted small mb-0">
                    Track your volunteer hours and discounts earned
                  </p>
                </div>
              </div>

              <div className="col-md-6 col-lg-3">
                <div className="bg-white rounded shadow p-4 text-center h-100">
                  <div className="bg-info bg-opacity-10 rounded-circle d-inline-flex align-items-center justify-content-center mb-3"
                       style={{width: '60px', height: '60px'}}>
                    <Bell className="text-info" size={30} />
                  </div>
                  <h5 className="fw-bold mb-2">Notifications</h5>
                  <p className="text-muted small mb-0">
                    Stay updated with appointment reminders and offers
                  </p>
                </div>
              </div>
            </div>

            {/* Subscribe Section */}
            <div className="bg-warning bg-opacity-10 rounded shadow p-5 mt-5 text-center">
              <h3 className="fw-bold text-dark mb-3">Be the First to Know!</h3>
              <p className="text-muted mb-4">
                Sign up for our mailing list to get notified when the dashboard launches
              </p>
              <a href="/#signup" className="btn btn-warning text-dark px-5 py-3 fw-semibold">
                Join Mailing List
              </a>
            </div>

            {/* FAQ */}
            <div className="mt-5">
              <h4 className="fw-bold text-dark mb-4 text-center">Frequently Asked Questions</h4>
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="bg-white rounded shadow-sm p-3">
                    <h6 className="fw-bold mb-2">When will the dashboard be available?</h6>
                    <p className="text-muted small mb-0">
                      We're working hard to launch it soon! Join our mailing list to be notified.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="bg-white rounded shadow-sm p-3">
                    <h6 className="fw-bold mb-2">Can I still book appointments?</h6>
                    <p className="text-muted small mb-0">
                      Absolutely! You can book appointments anytime from our homepage.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="bg-white rounded shadow-sm p-3">
                    <h6 className="fw-bold mb-2">Will I need to create an account?</h6>
                    <p className="text-muted small mb-0">
                      Optional! You can book without an account or create one to track appointments.
                    </p>
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="bg-white rounded shadow-sm p-3">
                    <h6 className="fw-bold mb-2">What features will be included?</h6>
                    <p className="text-muted small mb-0">
                      Appointment history, profile management, volunteer tracking, and exclusive offers!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="bg-dark text-white py-4 mt-5">
        <div className="container text-center">
          <p className="mb-0">© 2024 Mobile Body Therapy. All rights reserved.</p>
          <p className="small text-muted mb-0">Questions? Contact us at admin@mobilebodytherapy.com</p>
        </div>
      </footer>
    </div>
  );
}

export default Dashboard;